import React from 'react'
import { Badge as BsBadge } from 'react-bootstrap'

export function Badge({ props, children }) {
  return <BsBadge {...props}>{children}</BsBadge>
}
